import { Link } from "react-router-dom";

const ComplianceFooter = () => {
  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Company Info */}
          <div>
            <img 
              src="/lovable-uploads/e601b2a4-d63b-447f-b8f5-3e03625e19d6.png" 
              alt="Ascendry" 
              className="h-8 w-auto mb-4"
            />
            <p className="text-sm text-muted-foreground mb-2">
              Expert mentorship on demand with flexible token-based learning.
            </p>
            <p className="text-xs text-muted-foreground">
              © 2024 Ascendry. All rights reserved.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h3 className="font-semibold mb-3">Platform</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/mentors" className="text-muted-foreground hover:text-primary transition-colors">
                  Find Mentors
                </Link>
              </li>
              <li>
                <Link to="/auth/mentor" className="text-muted-foreground hover:text-primary transition-colors">
                  Become a Mentor
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-muted-foreground hover:text-primary transition-colors">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal & Compliance */}
          <div>
            <h3 className="font-semibold mb-3">Legal & Compliance</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy-policy" className="text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-muted-foreground hover:text-primary transition-colors">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-muted-foreground hover:text-primary transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Support & Contact */}
          <div>
            <h3 className="font-semibold mb-3">Contact</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="mailto:lance@blaqout.us" 
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  lance@blaqout.us
                </a>
              </li>
            </ul>
            
            <div className="mt-4 pt-4 border-t border-border">
              <p className="text-xs text-muted-foreground mb-1">Security & Compliance</p>
              <div className="flex items-center gap-2">
                <span className="text-xs bg-muted px-2 py-1 rounded text-muted-foreground">
                  PCI DSS Compliant
                </span>
                <span className="text-xs bg-muted px-2 py-1 rounded text-muted-foreground">
                  GDPR Ready
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-muted-foreground">
              Payments processed securely by Stripe.
            </p>
            <div className="flex items-center gap-4 text-xs text-muted-foreground">
              <span>🇺🇸 Based in USA</span>
              <span>🇪🇺 GDPR Compliant</span>
              <span>🔒 SSL Secured</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ComplianceFooter;